import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { JwtAuthService } from "./jwt-auth.service";
import { catchError } from "rxjs/internal/operators/catchError";
import { throwError } from "rxjs/internal/observable/throwError";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "@auth0/auth0-angular";
import { mergeMap } from "rxjs/operators";
import { Router } from "@angular/router";
import { timeout } from "d3";

@Injectable({
  providedIn: "root",
})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private jwtAuth: JwtAuthService,
    private auth:AuthService,
    private router:Router,
    private toastr: ToastrService  ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      console.log(this.router.url + " " + this.isPublic(this.router.url));
      if (this.isPublic(this.router.url)) {
        return next.handle(request);
      }
      return next.handle(request)
        .pipe(
          catchError((error: HttpErrorResponse) => {
            let errorMsg = '';
            if (error.error instanceof ErrorEvent) {
              console.log('this is client side error');
              errorMsg = `Error: ${error.error.message}`;
            }
            else {
              switch(error.status){
                case 401:
                  this.toastr.error("You are not authorized, please contact the administrators.")
                  timeout(()=>{
                    this.auth.logout({ returnTo: document.location.origin });
                  },2000)

                  break;
                  case 503:

                    this.router.navigate(["/user/map"]);
                    break;
              }

            }

            return throwError(()=> error);
          })
        )
    }

    isPublic(url: string){
      console.log("is public " + url);
      if(url.endsWith('DEC/GetDECSchools') || url.endsWith('DEC/GetDECSchoolById')) return true;
      if(url.endsWith('DST/GetDSTSchools') || url.endsWith('DST/GetDSTSchoolById')) return true;
      if(url.endsWith('PublicBookshop/GetBookShops') || url.endsWith('/public/bookshops')) return true;
      if(url.endsWith('/public/essay-report') || url.endsWith('DEC/GetSolarSchools')) return true;
      return false;
    }
  }
